import { ProposalDto } from '@gap/backend/app-services/proposal/models/ProposalDto';
import { createStoreContext } from 'reusable/mobx-store-utils/storeUtils';
import { ProposalStep3SingleDto } from '@gap/backend/app-services/proposal/models/ProposalStep3Dto';
import { formatCurrency, notNull } from '@gap/utils/utils';
import ProposalsViewStore from 'features/proposals/ProposalsViewStore';

export default class ProposalSectionPricingStore {
   sp

   constructor(sp: ProposalSectionPricingStoreProps) {
      this.sp = sp
   }

   get taxDescription() {
      return this.sp.proposalsViewStore.advisorOrg.taxDescription
   }

   get pricing() {
      return (this.sp.proposal.step3 || []).reduce<ProposalPricingWithServiceNames[]>((categories, category) => {
         // Drop in service names and filter included services, if need be
         const servicesWithNames = category.services.reduce<ProposalPricingWithServiceNames['services']>((services, service) => [
            ...services,
            ...((!this.sp.filteredServiceIds || this.sp.filteredServiceIds.includes(service.serviceId)) ? [{
               ...service,
               serviceName: notNull(this.sp.proposal.step2?.find(({ serviceId }) => serviceId === service.serviceId)).serviceName,
            }] : []),
         ], [])

         if (!servicesWithNames.length) return categories

         return [
            ...categories,
            {
               ...category,
               services: servicesWithNames,
            }
         ]
      }, []).sort((a, b) => this.getRateTypeOrder(a) - this.getRateTypeOrder(b));
   }

   getRateTypeOrder = ({ serviceRateType }: ProposalPricingWithServiceNames) => {
      switch (serviceRateType) {
         case 'Per month':
            return 0
         case 'Per annum':
            return 1
         case 'One-time fee':
            return 2
         case 'Per session':
            return 3
         case 'Per unit':
            return 4
      }
   }

   formatCurrency = (value: number) => formatCurrency({ value, currencyCode: notNull(this.sp.proposalsViewStore.advisorOrg.currencyCode) })
}

interface ProposalSectionPricingStoreProps {
   proposal: ProposalDto,
   proposalsViewStore: ProposalsViewStore,
   filteredServiceIds?: string[],
}

export type ProposalPricingWithServiceNames = ProposalStep3SingleDto & {
   services: { serviceName: string }[]
}

export const { Provider: ProposalSectionPricingStoreProvider, useProvidedStore: useProposalSectionPricingStore } =
   createStoreContext(ProposalSectionPricingStore)